<template>
	<div>
		<div class="filterbox" v-if="!isPC">
			<div class="f-nav">
				<span :class="{'active':navCurrent==0}" @click="navClick(0)">区域<i class="m-icon mi-dropdown"></i></span>
				<span :class="{'active':navCurrent==1}" @click="navClick(1)">单价<i class="m-icon mi-dropdown"></i></span>
				<span :class="{'active':navCurrent==2}" @click="navClick(2)">户型<i class="m-icon mi-dropdown"></i></span>
				<span :class="{'active':navCurrent==3}" @click="navClick(3)">筛选<i class="m-icon mi-dropdown"></i></span>
				<span :class="{'active':navCurrent==4}" @click="navClick(4)" v-if="$store.state.domainIndex!=2"><i class="m-icon mi-sort"></i></span>
			</div>
			<div class="f-list" :class="{'show':navCurrent==0}">
				<p :class="{'active':districtCurrent==-1&&!filterStr.locationId}" @click="districtClick(-1,'')">全部</p>
				<p :key="index" v-for="(item,index) in districtItems" :class="{'active':districtCurrent==index||(districtCurrent==-1&&filterStr.locationId==item.id)}" @click="districtClick(index,item.id)">{{item.name}}</p>
			</div>
			<div class="areabox" :class="{'show':navCurrent==0&&districtCurrent>=0||(navCurrent==0&&filterStr.locationId)}">
				<p :class="{'active':districtCurrent>=0&&areaCurrent==filterStr.locationId}" @click="areaClick(filterStr.locationId,-1)">全部</p>
				<p :key="index" v-for="(item,index) in areaItems" :class="{'active':areaCurrent==item.id||filterStr.plateId==item.id}" @click="areaClick(item.id,index)">{{item.name}}</p>
			</div>
			<div class="f-list" :class="{'show':navCurrent==1}">
				<p :class="{'active':priceCurrent==0&&!filterStr.priceId}" @click="priceClick('')">全部</p>
				<p :key="index" v-for="(item,index) in priceItems" :class="{'active':priceCurrent==item.id||filterStr.priceId==item.id}" @click="priceClick(item.id)">{{item.name}}</p>
			</div>
			<div class="f-list" :class="{'show':navCurrent==2}">
				<p :class="{'active':houseCurrent==0&&!filterStr.houseTypeId}" @click="houseClick('')">全部</p>
				<p :key="index" v-for="(item,index) in houseItems" :class="{'active':houseCurrent==item.id||filterStr.houseTypeId==item.id}" @click="houseClick(item.id)">{{item.name}}</p>
			</div>
			<div class="f-list selectbox" :class="{'show':navCurrent==3}">
				<slot v-if="$route.path!='/estateSale'">
				<p>销售状态（可多选）</p>
				<div><span :key="index" v-for="(item,index) in statusItems" :class="{'active':statusSelect.indexOf(item.id)!=-1||(filterStr.statusId&&filterStr.statusId.indexOf(item.id)!=-1)}" @click="statusClick(item.id)">{{item.name}}</span></div>
				</slot>
				<p>类型（可多选）</p>
				<div><span :key="index" v-for="(item,index) in typeItems" :class="{'active':typeSelect.indexOf(item.id)!=-1||(filterStr.typeId&&filterStr.typeId.indexOf(item.id)!=-1)}" @click="typeClick(item.id)">{{item.name}}</span></div>
				<span class="submitbtn" @click="submitSelect()">确定</span>
			</div>
			<div class="f-list" :class="{'show':navCurrent==4}">
				<p :key="index" v-for="(item,index) in sortItems" :class="{'active':sortCurrent==index||filterStr.sortNumber==index}" @click="sortClick(index)">{{item}}</p>
			</div>
		</div>
		<div class="box pcfilter" v-if="isPC">
			<div class="pf-list">
				<label>区　　域：</label>
				<a :class="{'active':districtCurrent==-1&&!filterStr.locationId}" @click="districtClick(-1,'')">全部</a>
				<a :key="index" v-for="(item,index) in districtItems" :class="{'active':districtCurrent==index||(districtCurrent==-1&&filterStr.locationId==item.id)}" @mouseenter="districtClick(index,item.id)" @click="areaClick(item.id,-1)">{{item.name}}</a>
			</div>
			<div class="pf-list" :class="{'pfarea':districtCurrent>=0}" v-if="districtCurrent>=0&&districtItems.length>0||filterStr.locationId">
				<!-- <a :class="{'active':areaCurrent==districtItems[districtCurrent].id}" @click="areaClick(districtItems[districtCurrent].id,-1)">全部</a> -->
				<a :key="index" v-for="(item,index) in areaItems" :class="{'active':areaCurrent==item.id||filterStr.plateId==item.id}" @click="areaClick(item.id,index)">{{item.name}}</a>
			</div>
			<div class="pf-list">
				<label>单　　价：</label>
				<a :class="{'active':priceCurrent==0&&!filterStr.priceId}" @click="priceClick('')">全部</a>
				<a :key="index" v-for="(item,index) in priceItems" :class="{'active':priceCurrent==item.id||filterStr.priceId==item.id}" @click="priceClick(item.id)">{{item.name}}</a>
			</div>
			<div class="pf-list">
				<label>户　　型：</label>
				<a :class="{'active':houseCurrent==0&&!filterStr.houseTypeId}" @click="houseClick('')">全部</a>
				<a :key="index" v-for="(item,index) in houseItems" :class="{'active':houseCurrent==item.id||filterStr.houseTypeId==item.id}" @click="houseClick(item.id)">{{item.name}}</a>
			</div>
			<div class="checkbox">
				<div class="pf-list">
					<label>类　　型：</label>
					<a :key="index" v-for="(item,index) in typeItems" :class="{'active':typeSelect.indexOf(item.id)!=-1||(filterStr.typeId&&filterStr.typeId.indexOf(item.id)!=-1)}" @click="typeClick(item.id)"><i class="m-icon"></i>{{item.name}}</a>
				</div>
				<div class="pf-list" v-if="$route.path!='/estateSale'">
					<label>销售状态：</label>
					<a :key="index" v-for="(item,index) in statusItems" :class="{'active':statusSelect.indexOf(item.id)!=-1||(filterStr.statusId&&filterStr.statusId.indexOf(item.id)!=-1)}" @click="statusClick(item.id)"><i class="m-icon"></i>{{item.name}}</a>
				</div>
				<!-- <span class="submitbtn" @click="submitSelect()">确定</span> -->
			</div>
			<div class="sortlist">
				<span :key="index" v-for="(item,index) in sortItems" :class="{'active':sortCurrent==index||filterStr.sortNumber==index}" @click="sortClick(index)">{{item}}</span>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'FilterMenu',
	props:{
		isPC:Boolean,
		filter:Object,
		clearFilter:Boolean,
	},
	data () {
		return {
			clear:this.clearFilter,
			districtItems:[],
			areaItems:[],
			priceItems:[],
			houseItems:[],
			statusItems:[],
			typeItems:[],
			sortItems:['默认排序','单价从低到高','单价从高到低'/*,'面积从小到大','面积从大到小'*/],
			navCurrent:-1,
			districtCurrent:-1,
			areaCurrent:'',
			priceCurrent:0,
			houseCurrent:0,
			statusSelect:[],
			typeSelect:[],
			sortCurrent:0,
			regionId:'',            //选中的区域id
			filterStr:[
				{locationId:''},      //区域参数Id
				{plateId:''},         //板块参数Id
				{priceId:''},
				{houseTypeId:''},
				{statusId:''},
				{typeId:''},
				{sortNumber:''},
				{mtxFisrtLocation:''}
			],
		}
	},
	mounted(){
		var _this = this;
		_this.getFilterItem(_this.storage.get('city'));
		_this.filterStr=_this.$store.state.filterStr;
		_this.sortCurrent=_this.$store.state.filterStr.sortNumber;
		_this.$emit('setFilter', _this.filterStr);
		if(_this.filterStr.locationId){
			_this.getAreaItem(_this.filterStr.locationId);
		}
		if(_this.filter){
			if(_this.filter.index==1){
				_this.districtClick(_this.filter.curr,_this.filter.code);
				_this.areaClick(_this.filter.code);
			}else if(_this.filter.index==2){
				_this.priceClick(_this.filter.code)
			}else if(_this.filter.index==3){
				_this.houseClick(_this.filter.code)
			}else if(_this.filter.index==4){
				_this.typeClick(_this.filter.code)
			}else if(_this.filter.index==5){
				_this.statusClick(_this.filter.code)
			}
		}
	},
	watch:{
		clearFilter:function(boo){
			if(boo){
				this.districtCurrent=-1;
				this.areaCurrent='';
				this.priceCurrent=0;
				this.houseCurrent=0;
				this.statusSelect=[];
				this.typeSelect=[];
				this.sortCurrent=0;
			}
		}
	},
	created(){
		window.addEventListener('setItem', ()=> {
			this.newVal = sessionStorage.getItem('watchStorage');
		})
	},
	methods:{
		getFilterItem:function(city){
			this.$http.get('/api/estateSearch/getLocationParams?locationId='+city.citySite).then((response)=>{
				this.districtItems = response.data.result.locationList
			}).catch((response)=>{
				console.log(response)
			})
			this.$http.get('/api/estateSearch/getQueryParams?type=2').then((response)=>{
				this.houseItems = response.data.result.list
			}).catch((response)=>{
				console.log(response)
			})
			this.$http.get('/api/estateSearch/getQueryParams?type=1').then((response)=>{
				this.priceItems = response.data.result.list
			}).catch((response)=>{
				console.log(response)
			})
			this.$http.get('/api/estateSearch/getQueryParams?type=4').then((response)=>{
				this.statusItems = response.data.result.list
			}).catch((response)=>{
				console.log(response)
			})
			this.$http.get('/api/estateSearch/getQueryParams?type=3').then((response)=>{
				this.typeItems = response.data.result.list
			}).catch((response)=>{
				console.log(response)
			})
		},
		getAreaItem:function(id){
			this.$http.get('/api/estateSearch/getLocationParams?locationId='+id).then((response)=>{
				this.areaItems = response.data.result.locationList
			}).catch((response)=>{
				console.log(response)
			})
		},
		navClick:function(index){
			if(this.navCurrent==index){
				this.navCurrent=-1
			}else{
				this.navCurrent=index
			}
		},
		districtClick:function(index,id){
			this.districtCurrent=index;
			if(index>=0){
				this.regionId = id;
				this.getAreaItem(id);
			}else{
				this.regionId = '';
				this.areaCurrent='';
				this.navCurrent=-1;
				this.filterStr.locationId=id;
				this.filterStr.plateId='';
				this.$emit('setFilter', this.filterStr)
			}
		},
		areaClick:function(id,index){
			this.areaCurrent=id;
			this.navCurrent=-1;
			if(index>=0){
				this.filterStr.locationId=this.regionId;
				this.filterStr.plateId=id;
			}else{
				this.filterStr.locationId=id;
				this.filterStr.plateId='';
			}
			this.$emit('setFilter', this.filterStr)
		},
		priceClick:function(id){
			this.filterStr.priceId=id;
			this.$emit('setFilter', this.filterStr)
			this.priceCurrent=id;
			this.navCurrent=-1;
		},
		houseClick:function(id){
			this.filterStr.houseTypeId=id;
			this.$emit('setFilter', this.filterStr)
			this.houseCurrent=id;
			this.navCurrent=-1;
		},
		statusClick:function(value){
			if(this.$store.state.filterStr.statusId){
				this.statusSelect=this.$store.state.filterStr.statusId.split(',');
			}
			if(this.statusSelect.indexOf(value)!=-1){
				this.statusSelect.splice(this.statusSelect.indexOf(value),1)
			}else{
				this.statusSelect.push(value)
			}
			var statu='';
			this.statusSelect.forEach((item)=>{
				statu+=item+','
			})
			this.filterStr.statusId=statu.slice(0,statu.length-1);
			this.$store.commit('updateFilterStr',this.filterStr);
			if(this.isPC){
				this.submitSelect();
			}
		},
		typeClick:function(value){
			if(this.$store.state.filterStr.typeId){
				this.typeSelect=this.$store.state.filterStr.typeId.split(',');
			}
			if(this.typeSelect.indexOf(value)!=-1){
				this.typeSelect.splice(this.typeSelect.indexOf(value),1)
			}else{
				this.typeSelect.push(value)
			}
			var type='';
			this.typeSelect.forEach((item)=>{
				type+=item+','
			})
			this.filterStr.typeId=type.slice(0,type.length-1);
			this.$store.commit('updateFilterStr',this.filterStr);
			if(this.isPC){
				this.submitSelect();
			}
		},
		submitSelect:function(){
			// var statu='',type='';
			// this.statusSelect.forEach((item)=>{
			// 	statu+=item+','
			// })
			// this.typeSelect.forEach((item)=>{
			// 	type+=item+','
			// })
			// this.filterStr.statusId=statu.slice(0,statu.length-1);
			// this.filterStr.typeId=type.slice(0,type.length-1);
			this.filterStr=this.$store.state.filterStr;
			this.$emit('setFilter', this.filterStr);
			this.navCurrent=-1;
		},
		sortClick:function(index){
			this.sortCurrent=index;
			this.filterStr.sortNumber=index;
			this.$emit('setFilter', this.filterStr);
			this.navCurrent=-1;
		}
	}
}
</script>

<style scoped>
.filterbox{position:relative;z-index:8;}
.f-nav{display:flex;justify-content:space-between;padding:0 25px 9px;line-height:25px;background:#fff;box-shadow:0 2px 2px #e9e9e9;color:#666;}
.f-nav span.active{color:#333;font-weight:bold;}
.f-nav span.active .mi-sort{opacity:1}
.mi-dropdown{width:7px;height:4px;background-position:-147px 0;margin:6px 0 0 5px;}
.mi-sort{width:13px;height:16px;background-position:-18px 0;opacity:0.6;}
.f-list{position:absolute;z-index:1;background:#fff;box-shadow:0 2px 2px #e9e9e9;padding:6px 15px 15px;left:0;right:0;top:34px;display:none;color:#777;max-height:232px;overflow:auto;-webkit-overflow-scrolling:touch;}
.f-list.show{display:block;}
.filterbox p{padding-left:10px;line-height:30px;}
.filterbox p.active{color:#2e303a;font-weight:bold;background:rgba(0,0,0,0.1);}
.areabox{display:none;background:#fff;position:absolute;z-index:1;left:50%;top:34px;height:233px;overflow:auto;right:1px;box-shadow:0 1px 1px 0 rgba(0,0,0,0.1);padding:10px 15px;color:#777;-webkit-overflow-scrolling:touch;}
.areabox.show{display:block;}
.selectbox{max-height:none;padding-bottom:30px;}
.selectbox p{color:#333;}
.selectbox div{margin-top:-5px;margin-bottom:15px;padding-right:10px;}
.selectbox span{display:inline-block;margin-left:10px;line-height:25px;font-size:12px;background:#eee;color:#777;padding:1px 10px 0;border-radius:3px;margin-top:10px;}
.selectbox span.active{background:#ffd03d;color:#2e303a;}
.selectbox .submitbtn{display:block;margin-right:10px;line-height:43px;margin-top:30px;border-radius:30px;font-size:15px;background:#ffd03d;color:#333;text-align:center;}
.pcfilter{padding:25px 0;}
.pf-list{position:relative;padding:6px 0 6px 85px;line-height:22px;min-height:22px;}
.pf-list label{position:absolute;left:0;top:5px;font-weight:700;}
.pf-list a{margin-right:15px;font-size:13px;cursor:pointer;color:#888;}
.pf-list a:hover{color:#555;text-decoration: underline;}
.pf-list a.active{color:#ffd03d;font-weight:700;}
.pfarea{padding-top:0;font-size:12px;padding-left:130px;}
.checkbox{position:relative;}
.checkbox a.active{font-weight:400;color:#333;}
.checkbox a:hover{text-decoration:none;}
.sortlist{font-size:13px;line-height:36px;margin-top:25px;background:#f5f5fa;}
.sortlist span{display:inline-block;padding:0 13px;cursor:pointer;}
.sortlist span+span{margin-left:-1px;}
.sortlist .active{background:#ffd03d;color:#333;}
</style>



// WEBPACK FOOTER //
// src/components/public/FilterMenu.vue